module.exports = __webpack_public_path__ + "d96d495a6e0749c57cc4c738f10f5c31.png";